// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_organization_job_position.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum com.diagnocat.model.OrganizationJobPosition
 */
export const OrganizationJobPosition = proto3.makeEnum(
  "com.diagnocat.model.OrganizationJobPosition",
  [
    {no: 0, name: "OrganizationJobPositionInvalidValue"},
    {no: 1, name: "OrganizationJobPositionChiefDentalOfficer"},
    {no: 2, name: "OrganizationJobPositionTreatmentCoordinator"},
    {no: 3, name: "OrganizationJobPositionDentalAssistant"},
    {no: 4, name: "OrganizationJobPositionDentalTechnician"},
    {no: 5, name: "OrganizationJobPositionGeneralDentist"},
    {no: 6, name: "OrganizationJobPositionPeriodontist"},
    {no: 7, name: "OrganizationJobPositionProsthodontist"},
    {no: 8, name: "OrganizationJobPositionOrthodontist"},
    {no: 9, name: "OrganizationJobPositionPediatricDentist"},
    {no: 10, name: "OrganizationJobPositionOralAndMaxillofacialSurgeon"},
    {no: 11, name: "OrganizationJobPositionOralAndMaxillofacialRadiologist"},
    {no: 12, name: "OrganizationJobPositionAestheticDentist"},
    {no: 13, name: "OrganizationJobPositionDentalHygienist"},
    {no: 16, name: "OrganizationJobPositionEndodontist"},
    {no: 17, name: "OrganizationJobPositionDentalTherapist"},
    {no: 18, name: "OrganizationJobPositionImplantologist"},
    {no: 101, name: "OrganizationJobPositionGeneralPractitioner"},
    {no: 102, name: "OrganizationJobPositionInternist"},
    {no: 103, name: "OrganizationJobPositionPediatrician"},
    {no: 104, name: "OrganizationJobPositionGeneralSurgeon"},
    {no: 105, name: "OrganizationJobPositionCardiologist"},
    {no: 106, name: "OrganizationJobPositionNeurologist"},
    {no: 107, name: "OrganizationJobPositionOphthalmologist"},
    {no: 108, name: "OrganizationJobPositionOtolaryngologist"},
    {no: 109, name: "OrganizationJobPositionDermatologist"},
    {no: 110, name: "OrganizationJobPositionObstetricianGynecologist"},
    {no: 111, name: "OrganizationJobPositionUrologist"},
    {no: 112, name: "OrganizationJobPositionEndocrinologist"},
    {no: 113, name: "OrganizationJobPositionGastroenterologist"},
    {no: 114, name: "OrganizationJobPositionPulmonologist"},
    {no: 115, name: "OrganizationJobPositionRheumatologist"},
    {no: 116, name: "OrganizationJobPositionOncologist"},
    {no: 117, name: "OrganizationJobPositionOrthopedicSurgeon"},
    {no: 118, name: "OrganizationJobPositionPsychiatrist"},
    {no: 119, name: "OrganizationJobPositionAllergistImmunologist"},
    {no: 120, name: "OrganizationJobPositionInfectiousDiseaseSpecialist"},
    {no: 121, name: "OrganizationJobPositionNephrologist"},
    {no: 123, name: "OrganizationJobPositionRadiologist"},
    {no: 124, name: "OrganizationJobPositionEmergencyPhysician"},
    {no: 125, name: "OrganizationJobPositionNeurosurgeon"},
    {no: 126, name: "OrganizationJobPositionPlasticSurgeon"},
    {no: 127, name: "OrganizationJobPositionGeriatrician"},
    {no: 128, name: "OrganizationJobPositionPhysiatrist"},
    {no: 129, name: "OrganizationJobPositionHematologist"},
    {no: 130, name: "OrganizationJobPositionNeonatologist"},
    {no: 14, name: "OrganizationJobPositionOther"},
    {no: 15, name: "OrganizationJobPositionOfficeManager"},
    {no: 122, name: "OrganizationJobPositionAnesthesiologist"},
  ],
);

